import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React, { useState, useEffect } from 'react';
import uniqid from 'uniqid';
import Button from "../Button";
import { ChevronDown } from "../../icons";
import clsx from 'clsx';
import { OptionsAlignmentTypes } from "../../types/Dropdown";
import { createStyles } from "./styles";

var Dropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  // Local state
  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),openDropdown = _useState2[0],setOpenDropdown = _useState2[1];
  var _useState3 = useState(uniqid()),_useState4 = _slicedToArray(_useState3, 1),DROPDOWN_ID = _useState4[0];
  var CLOSE_ALL_NON_CLICKED_DROPDOWNS_EVENT_NAME = 'CLOSE_ALL_NON_CLICKED_DROPDOWNS';

  // Component actions
  var onDropdownClick = function onDropdownClick(e) {
    e.stopPropagation();
    var CLOSE_ALL_NON_CLICKED_DROPDOWNS_EVENT = new CustomEvent(
    CLOSE_ALL_NON_CLICKED_DROPDOWNS_EVENT_NAME,
    {
      detail: DROPDOWN_ID
    });

    document.dispatchEvent(CLOSE_ALL_NON_CLICKED_DROPDOWNS_EVENT);
    setOpenDropdown(!openDropdown);
  };

  // Close dropdown on any click outside the dropdown itself or it's options (except for the other dropdowns click).
  function onDocumentClick(e) {
    var target = e.target;
    if (!target.dataset['dropdown-option'] && openDropdown === true) {
      setOpenDropdown(false);
    }
  }
  // Close dropdown on any other dropdown click.
  function closeDropdownOnOtherDropdownClick(e) {
    if (e.detail !== DROPDOWN_ID) {
      setOpenDropdown(false);
    }
  }

  // Effects
  useEffect(function () {
    document.addEventListener('click', onDocumentClick);
    return function () {
      document.removeEventListener('click', onDocumentClick);
    };
  });

  useEffect(function () {
    document.addEventListener(
    CLOSE_ALL_NON_CLICKED_DROPDOWNS_EVENT_NAME,
    closeDropdownOnOtherDropdownClick // It's not possible to add custom event handler to document or window object without type casting.
    );
    return function () {
      document.removeEventListener(
      CLOSE_ALL_NON_CLICKED_DROPDOWNS_EVENT_NAME,
      closeDropdownOnOtherDropdownClick);

    };
  });

  // Concomitant layout
  var name = props.name,openedElement = props.openedElement,closedElement = props.closedElement;

  var standardDropdownElement = /*#__PURE__*/
  React.createElement(Button, {
    color: "primary",
    size: "large",
    onClick: onDropdownClick,
    rightIconProp: /*#__PURE__*/React.createElement(ChevronDown, null),
    dataSet: { 'data-dropdown-id': DROPDOWN_ID } },

  name);



  var keyPressHandler = function keyPressHandler(
  e,
  optionValue,
  callback)



  {
    if (e.keyCode === 13) {
      if (callback) {
        callback(optionValue, e);
      }
    }
  };

  // Checks if the passed element is valid as a JSX Element and returns a new element,
  // based on the passed one and with added onClick and children props.
  var createDropdownElem = function createDropdownElem(elem) {
    return openedElement && /*#__PURE__*/React.isValidElement(elem) ? /*#__PURE__*/
    React.cloneElement(elem, {
      'data-dropdown-id': DROPDOWN_ID,
      onClick: onDropdownClick,
      name: name
    }) :
    standardDropdownElement;
  };
  var OpenedDropdownElem = function OpenedDropdownElem() {return createDropdownElem(openedElement);};
  var ClosedDropdownElem = function ClosedDropdownElem() {return createDropdownElem(closedElement);};

  var options = props.options,_props$optionsAlignme = props.optionsAlignment,optionsAlignment = _props$optionsAlignme === void 0 ? OptionsAlignmentTypes.BOTTOM_RIGHT : _props$optionsAlignme,className = props.className;
  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.dropdownWrapper, className), ref: ref },
    openDropdown ? /*#__PURE__*/React.createElement(OpenedDropdownElem, null) : /*#__PURE__*/React.createElement(ClosedDropdownElem, null),
    openDropdown && /*#__PURE__*/
    React.createElement("ul", { className: clsx(classes.optionsList, classes[optionsAlignment]), role: "menu" },
    _mapInstanceProperty(options).call(options, function (option) {var _context;
      var optionKey = _concatInstanceProperty(_context = "option_value-".concat(option.value, "_label-")).call(_context, option.label);
      return option.renderFunc ?
      option.renderFunc(optionKey) : /*#__PURE__*/

      React.createElement("li", {
        className: clsx(classes.option, option.className),
        key: optionKey,
        "data-value": option.value,
        "data-role": "dropdown-option",
        onClick: function onClick(e) {
          onDropdownClick(e);
          if (option.onOptionClick) {
            option.onOptionClick(option.value, e);
          }
        },
        onKeyDown: function onKeyDown(e) {
          e.stopPropagation();
          keyPressHandler(e, option.value, option.onOptionClick);
        },
        role: "menuitem",
        tabIndex: 0 },

      option.label);


    }))));




});
Dropdown.displayName = 'Dropdown';

export default Dropdown;
//# sourceMappingURL=index.js.map